'use strict'; // https://github.com/tc39/proposal-iterator-helpers

var $ = require('../internals/export');

var iterate = require('../internals/iterate');

var aCallable = require('../internals/a-callable');

var getIteratorDirect = require('../internals/get-iterator-direct');

var $TypeError = TypeError;
$({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  reduce: function reduce(reducer
  /* , initialValue */
  ) {
    var record = getIteratorDirect(this);
    aCallable(reducer);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value);
      }
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw $TypeError('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});